import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useNavigate } from 'react-router-dom'
import DidTable from '../../components/new_component/DidTable'

import { menu, input, sip, did, employee } from '../../translate'
import Api from '../../Api'
import { toast } from 'react-toastify'

function MainNumber() {
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [viewMode, setViewMode] = useState('table')
  const [numbers, setNumbers] = useState([])
  const [filteredNumbers, setFilteredNumbers] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(9)

  useEffect(() => {
    fetchNumbers()
  }, [viewMode])

  useEffect(() => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase()
      const filtered = numbers.filter(number => {
        const phone = `${number.pref || ''}${number.did || ''}`
        const searchableFields = [
          phone,
          number.notes,
          number.output?.output || number.redirect_output,
          number.dlines,
          number.nodline,
        ]
        return searchableFields.some(field => 
          field !== null && 
          field !== undefined && 
          String(field).toLowerCase().includes(query)
        )
      })
      setFilteredNumbers(filtered)
    } else {
      setFilteredNumbers(numbers)
    }
    setPage(0) // Reset to first page when filter changes
  }, [searchQuery, numbers])

  const fetchNumbers = async () => {
    setLoading(true)
    try {
      const response = await Api.getDid('', 100, 1)
      if (response?.data?.status === 'ok') {
        // Handle both response structures: response.data.did or response.data.data
        const data = response.data.did || response.data.data || []
        setNumbers(data)
        setFilteredNumbers(data)
      }
    } catch (error) {
      console.error('Error fetching main numbers:', error)
      toast.error('Error fetching main numbers')
    } finally {
      setLoading(false)
    }
  }

  const handleSearchChange = (value) => {
    setSearchQuery(value)
  }

  const handleAdd = () => {
    navigate('/main_number/add')
  }

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode)
    }
  }

  const handleEdit = (item) => {
    console.log(item)
    navigate(`/main_number/${item.pref}${item.did}?phone=${item.pref}${item.did}&provider=${item.provider} `)
  }

  const handleDelete = async (item) => {
    const deleteText = langIndex === 1 ? "Are you sure you want to delete?" :
      langIndex === 2 ? "Вы уверены, что хотите удалить?" :
        "Վստա՞հ եք, որ ցանկանում եք ջնջել"
    
    if (window.confirm(deleteText)) {
      try {
        const phoneNumber = `${item.pref}${item.did}`
        await Api.deleteDid(phoneNumber, item.provider || '')
        setNumbers(prev => prev.filter(n => !(n.pref === item.pref && n.did === item.did && n.profile === item.profile)))
        setFilteredNumbers(prev => prev.filter(n => !(n.pref === item.pref && n.did === item.did && n.profile === item.profile)))
        toast.success('Main number deleted successfully')
      } catch (error) {
        console.error('Error deleting main number:', error)
        toast.error('Error deleting main number')
      }
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <Wrapper>
      {viewMode === 'table' ? (
        <>
         
          <DidTable title={menu.did[langIndex]} viewMode={viewMode} onViewModeChange={handleViewModeChange} data={numbers} setData={setNumbers} loading={loading} />
        </>
      ) : (
        <div className="tableParent">
        
        </div>
      )}
    </Wrapper>
  )
}

export default MainNumber
